import Vue from 'vue'
import { FluxCompressionMode } from '@/enum/FluxCompressionMode'

Vue.filter('compressionMode', function(value: FluxCompressionMode ) {
  if (value) {
    switch(value){
      case FluxCompressionMode.NoCompression:
        return 'Générer un (des) feed(s) non compressé(s)'
      case FluxCompressionMode.DirectGZipOnly:
        return 'Générer un (des) feed(s) compressé(s) en GZip (recommandé)'      
      case FluxCompressionMode.UncompressedAndGZip:
        return 'Délivrer un (des) feed(s) compressé(s) et non compressé(s)'      
    }        
    return ''
  }
})